module.exports = __webpack_public_path__ + "media/bootstrap-icons/x-octagon-2c742393.svg";